// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__NIPuQ","statsTitle":"Stats_statsTitle__i4Nhi","statsValue":"Stats_statsValue__nHPpl"};